import React, { Suspense, lazy } from "react"
import { HashRouter as Router, Route, Switch } from "react-router-dom"
import { Spin, ConfigProvider } from "antd"
import Header from "@components/Header"
import zhCN from "antd/es/locale/zh_CN"
import { Provider } from "mobx-react"
import store from "./store"
import moment from "moment"
import "moment/locale/zh-cn"
import Graph from "@routes/Graph"
import Insights from "@routes/Insights"
import Parks from "@routes/Parks"
import "./App.scss"
moment.locale("zh-cn")

// const Graph = lazy(() => import("./routes/Graph"))
// const Insights = lazy(() => import("./routes/Insights"))
// const MapIndoor = lazy(() => import("./routes/MapIndoor"))

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Provider store={store}>
        <Router>
          <div className="pg-wrap flex flex-column">
            <Header />
            <div className="pg-content flex flex-1">
              <Suspense fallback={<Spin />}>
                <Switch>
                  {/* <Route exact path="/map" component={MapIndoor} /> */}
                  {/* <Route exact path={["/", "/:type"]} component={Dashboard} /> */}
                  <Route exact path="/" component={Insights} />
                  <Route exact path="/graph" component={Graph} />
                  <Route exact path="/park" component={Parks} />
                </Switch>
              </Suspense>
            </div>
          </div>
        </Router>
      </Provider>
    </ConfigProvider>
  )
}

export default App
